export default "__VITE_ASSET__CV_zTR60__"